export default {
  loading: state => state.loading,
  scaleSummaryLoading: state => state.scaleSummaryLoading
}
